var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard-square-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 6.5C2 4.61438 2 3.67157 2.58579 3.08579C3.17157 2.5 4.11438 2.5 6 2.5C7.88562 2.5 8.82843 2.5 9.41421 3.08579C10 3.67157 10 4.61438 10 6.5V8.5C10 10.3856 10 11.3284 9.41421 11.9142C8.82843 12.5 7.88562 12.5 6 12.5C4.11438 12.5 3.17157 12.5 2.58579 11.9142C2 11.3284 2 10.3856 2 8.5V6.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 19.5C2 18.5681 2 18.1022 2.15224 17.7346C2.35523 17.2446 2.74458 16.8552 3.23463 16.6522C3.60218 16.5 4.06812 16.5 5 16.5H7C7.93188 16.5 8.39782 16.5 8.76537 16.6522C9.25542 16.8552 9.64477 17.2446 9.84776 17.7346C10 18.1022 10 18.5681 10 19.5C10 20.4319 10 20.8978 9.84776 21.2654C9.64477 21.7554 9.25542 22.1448 8.76537 22.3478C8.39782 22.5 7.93188 22.5 7 22.5H5C4.06812 22.5 3.60218 22.5 3.23463 22.3478C2.74458 22.1448 2.35523 21.7554 2.15224 21.2654C2 20.8978 2 20.4319 2 19.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 16.5C14 14.6144 14 13.6716 14.5858 13.0858C15.1716 12.5 16.1144 12.5 18 12.5C19.8856 12.5 20.8284 12.5 21.4142 13.0858C22 13.6716 22 14.6144 22 16.5V18.5C22 20.3856 22 21.3284 21.4142 21.9142C20.8284 22.5 19.8856 22.5 18 22.5C16.1144 22.5 15.1716 22.5 14.5858 21.9142C14 21.3284 14 20.3856 14 18.5V16.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14 5.5C14 4.56812 14 4.10218 14.1522 3.73463C14.3552 3.24458 14.7446 2.85523 15.2346 2.65224C15.6022 2.5 16.0681 2.5 17 2.5H19C19.9319 2.5 20.3978 2.5 20.7654 2.65224C21.2554 2.85523 21.6448 3.24458 21.8478 3.73463C22 4.10218 22 4.56812 22 5.5C22 6.43188 22 6.89782 21.8478 7.26537C21.6448 7.75542 21.2554 8.14477 20.7654 8.34776C20.3978 8.5 19.9319 8.5 19 8.5H17C16.0681 8.5 15.6022 8.5 15.2346 8.34776C14.7446 8.14477 14.3552 7.75542 14.1522 7.26537C14 6.89782 14 6.43188 14 5.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.8a5a7faf1004cff30aebd9ab9dc47038.svg";
export { ForwardRef as ReactComponent };